import { useEffect, useRef, useState } from "react";

/**
 * Lightweight animated counter that starts when scrolled into view.
 */
export default function CountUp({
  end = 100,
  suffix = "",
  duration = 1800,
  className = "",
  testid,
}) {
  const [value, setValue] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !started.current) {
            started.current = true;
            const startTime = performance.now();
            const tick = (now) => {
              const elapsed = now - startTime;
              const t = Math.min(elapsed / duration, 1);
              // easeOutCubic
              const eased = 1 - Math.pow(1 - t, 3);
              setValue(Math.floor(eased * end));
              if (t < 1) requestAnimationFrame(tick);
              else setValue(end);
            };
            requestAnimationFrame(tick);
          }
        });
      },
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [end, duration]);

  return (
    <span ref={ref} className={className} data-testid={testid}>
      {value.toLocaleString()}
      {suffix}
    </span>
  );
}
